import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-settings',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public section: string = 'events';
    public sections: string[] = ['events', 'rules'];
    public sectionLabels: any = { events: '이벤트 대화', rules: '프롬프트 규칙' };

    // 이벤트 대화
    public dialogues: any[] = [];
    public editDialogue: any = null;

    // 프롬프트 규칙
    public rules: any[] = [];
    public editRule: any = null;

    public loading: boolean = true;

    public eventTypes: string[] = ['greeting', 'farewell', 'chitchat', 'joke', 'error', 'maintenance'];
    public ruleCategories: string[] = ['distortion', 'injection', 'template', 'guardrail'];
    public ruleTypes: string[] = ['regex', 'keyword', 'semantic', 'system_prompt'];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        if (this.section === 'events') {
            const { code, data } = await wiz.call("event_dialogues");
            if (code === 200) this.dialogues = Array.isArray(data) ? data : [];
        } else {
            const { code, data } = await wiz.call("prompt_rules");
            if (code === 200) this.rules = Array.isArray(data) ? data : [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async switchSection(s: string) {
        this.section = s;
        this.editDialogue = null;
        this.editRule = null;
        await this.load();
    }

    // --- 이벤트 대화 ---
    public openDialogue(item?: any) {
        if (item) {
            this.editDialogue = JSON.parse(JSON.stringify(item));
        } else {
            this.editDialogue = {
                id: '', event_type: 'greeting', trigger_keywords: '',
                trigger_pattern: '', response_text: '', response_variants: '',
                priority: 0, is_active: true
            };
        }
        this.service.render();
    }

    public closeDialogue() {
        this.editDialogue = null;
        this.service.render();
    }

    public async saveDialogue() {
        if (!this.editDialogue) return;
        const payload = { ...this.editDialogue };
        const { code } = await wiz.call("event_dialogue_save", { data: JSON.stringify(payload) });
        if (code === 200) {
            this.editDialogue = null;
            await this.load();
        } else {
            await this.service.alert.show({ title: '오류', message: '저장에 실패했습니다.', action: '확인' });
        }
    }

    // --- 프롬프트 규칙 ---
    public openRule(item?: any) {
        if (item) {
            this.editRule = JSON.parse(JSON.stringify(item));
        } else {
            this.editRule = {
                id: '', name: '', category: 'guardrail', rule_type: 'keyword',
                pattern: '', replacement: '', priority: 0, is_active: true
            };
        }
        this.service.render();
    }

    public closeRule() {
        this.editRule = null;
        this.service.render();
    }

    public async saveRule() {
        if (!this.editRule) return;
        const payload = { ...this.editRule };
        const { code } = await wiz.call("prompt_rule_save", { data: JSON.stringify(payload) });
        if (code === 200) {
            this.editRule = null;
            await this.load();
        } else {
            await this.service.alert.show({ title: '오류', message: '저장에 실패했습니다.', action: '확인' });
        }
    }
}

export default PortalNrichadminAdminSettingsComponent;